
import { Vue } from "vue-class-component";

export default class Shopify extends Vue {}
